import { BettingState } from "@ppb/betslip-core";
import { formatOdds } from "@ppb/formatters";
import type { Odds, OddsFormat } from "@ppb/formatters";

const toOdds = (odds: BettingState.Odds): Odds => ({
  decimal: odds.decimalOdds,
  fractional: odds.fractionalOdds,
  american: odds.americanOdds,
});

/**
 * Fixed-odds price boosts show a strict 2 decimal places. Do not delegate the
 * decimal branch to formatOdds: its DECIMAL format drops the decimals for whole
 * numbers >= 1000, rendering "1000" where a boost must read "1000.00".
 *
 * Any other format, including no format at all, falls back to fractional.
 */
const formatFixedOdds = (decimalOdds: number, format?: OddsFormat): string =>
  format === "DECIMAL" ? decimalOdds.toFixed(2) : formatOdds({ decimal: decimalOdds }, "FRACTIONAL", false);

export type { Odds, OddsFormat };
export { toOdds, formatFixedOdds };
